
<template>
  <v-list-item v-if="album !== null">
    <v-list-item-icon>
      <slot name="button" />
    </v-list-item-icon>
    <v-list-item-avatar class="mr-4">
      <img :src="album.images[0].url" />
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>{{album.name}}</v-list-item-title>
      <v-list-item-subtitle>
        {{album.artists.map(a => a.name).join(', ')}}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import cms from '../../cms'

@Component
export default class BuilderAlbumTile extends Vue {
  @Prop() value!: string

  album: {
    images: { url: string }[]
    name: string
    artists: { name: string }[]
  } | null = null

  created () {
    this.watchQuery(this.value)
  }

  @Watch('value')
  async watchQuery (value: string) {
    if (this.value === '') {
      this.$emit('input', '')
      return
    }

    try {
      const album = await cms.api.spotify.getAlbum(value)

      if (album) {
        this.album = album

        this.$emit('input', this.value)
      }
    } catch (e) {
      alert('Album not found')
    }
  }
}
</script>

<style scoped></style>
